<template>
    <Notification
        v-if="notes.length"
        variant="warning"
        padding="l"
        :tier="2"
        :title="title"
        class="important-notes">
        <div class="important-notes-note">
            <TruncateText
                v-for="(note, index) in notes"
                :key="index"
                :text="sanitize(note.Text)"
                :rows="4" />
        </div>
    </Notification>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { Note } from '@/api/Cart/cart.interfaces';
    import { sanitize } from '@shared/utils/sanitize';
    import TruncateText from '@ui/components/TruncateText/TruncateText.vue';
    import Notification from '@ui/components/Notification/Notification.vue';

    export default defineComponent({
        name: 'ImportantNotes',
        methods: { sanitize },
        components: { Notification, TruncateText },
        props: {
            notes: {
                type: Array as PropType<Note[]>,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
        },
    });
</script>

<style scoped lang="scss">
    @forward 'ImportantNotes';
</style>
